import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider, store } from '@link/gds-admin/stores';
import '@link/gds-admin/i18n';
import '@link/gds-admin/styles/index.css';
import App from '@link/gds-admin/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
